module.exports = __webpack_public_path__ + "static/img/COVER-8.7009f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-8.png
// module id = lhUi
// module chunks = 31